import './cases-content.scss';
import 'magnific-popup';
import 'slick-carousel';

export default () => {
	$( '.js-popup-video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false,
	} );

	$( '.js-case-slider' ).slick( {
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		arrows: true,
		prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-arrow"></i></button>',
		nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-arrow"></i></button>',
		dots: true,
		responsive: [ {
			breakpoint: 991,
			settings: 'unslick',
		} ],
	} );

	$( window ).on( 'resize', function () {
		$( '.js-case-slider' ).slick( 'resize' );
	} );
};
